import { LazyLoadImage } from 'react-lazy-load-image-component';
import { HelpCenterFAQSectionProps } from '../HelpCenter.types';
import HelpCenterFAQComponent from '../HelpCenterFAQComponent/HelpCenterFAQComponent';
import { sanityDataset, sanityImagesBaseUrl, sanityProjectId } from '../../../../sanity.io/config';
import './HelpCenterFAQSection.scss';

function HelpCenterFAQSection({ sanityData }: HelpCenterFAQSectionProps) {
  return (
    <section className="faq-section">
      <div className="faq-section-title">FAQs</div>
      <div className="faq-section-body">
        {sanityData.map(item => (
          <HelpCenterFAQComponent
            key={item.slug.current}
            faqs={item.faqs}
            title={item.title}
            icon={
              <LazyLoadImage
                src={`${sanityImagesBaseUrl}/${sanityProjectId}/${sanityDataset}/${item.icon.asset._ref
                  .split('image-')[1]
                  .replace('-svg', '.svg')}?w=1000&h=1000&fit=max`}
                alt={item.slug.current}
              />
            }
          />
        ))}
      </div>
    </section>
  );
}
export default HelpCenterFAQSection;
